import {
  isHSEWasteDisposal,
  isHSEWasteDisposalSlops,
  isHSEWasteDisposalSludge,
} from "@features/vessel-call/vessel-call-status/PortServices/flow/hse/utils";
import PortServiceUploadFiles from "@features/vessel-call/vessel-call-status/PortServices/form/PortServiceUploadFiles";
import ShipChandlingUploadFields from "@features/vessel-call/vessel-call-status/PortServices/form/ship-chandling/ShipChandlingUploadFields";
import ShipToShipUploadFields from "@features/vessel-call/vessel-call-status/PortServices/form/ship-to-ship/ShipToShipUploadFields";
import {
  DEBUNKERING_MAP,
  HSE,
  isShipChandlingLifeboatsService,
  isShipToShipService,
  serviceSubtypeParticularities,
  WASTE_DISPOSAL_MAP,
} from "@features/vessel-call/vessel-call-status/PortServices/form/utils";

type PortServiceUploadResolverProps = {
  serviceCategory?: string;
  serviceType?: string;
  serviceSubType?: string;
};

const PortServiceUploadResolver = ({
  serviceCategory,
  serviceType,
  serviceSubType,
}: PortServiceUploadResolverProps) => {
  const isHseWasteDisposal = isHSEWasteDisposal(serviceCategory ?? "", serviceType ?? "");
  const isShipToShip = isShipToShipService(serviceCategory, serviceType, serviceSubType);
  const isShipChandlingLifeboats = isShipChandlingLifeboatsService(serviceCategory, serviceType);

  if (serviceCategory === WASTE_DISPOSAL_MAP.CATEGORY && !!serviceType) {
    const fieldName = serviceSubtypeParticularities[serviceType]?.uploadFieldName;

    return (
      <PortServiceUploadFiles
        title={serviceSubtypeParticularities[serviceType]?.uploadTitle ?? ""}
        fileType={
          serviceType === WASTE_DISPOSAL_MAP.SLOPS
            ? serviceSubtypeParticularities[serviceType]?.fileType
            : undefined
        }
        fieldName={fieldName}
        testId={fieldName ? `${fieldName}-upload` : undefined}
      />
    );
  }

  if (
    isHseWasteDisposal &&
    (isHSEWasteDisposalSludge(serviceCategory ?? "", serviceType ?? "", serviceSubType ?? "") ||
      isHSEWasteDisposalSlops(serviceCategory ?? "", serviceType ?? "", serviceSubType ?? ""))
  ) {
    const fieldName = serviceSubtypeParticularities[serviceSubType ?? ""]?.uploadFieldName;

    return (
      <PortServiceUploadFiles
        title={serviceSubtypeParticularities[serviceSubType ?? ""]?.uploadTitle ?? ""}
        fileType={
          serviceSubType === HSE.SLOPS
            ? serviceSubtypeParticularities[serviceSubType]?.fileType
            : undefined
        }
        fieldName={fieldName}
        testId={fieldName ? `${fieldName}-upload` : undefined}
      />
    );
  }

  if (isShipToShip) {
    return <ShipToShipUploadFields />;
  }

  if (isShipChandlingLifeboats) {
    return <ShipChandlingUploadFields />;
  }

  if (serviceCategory === DEBUNKERING_MAP.CATEGORY) {
    return (
      <PortServiceUploadFiles
        title={"bunker-delivery-note"}
        fileType="BUNKER_DELIVERY_NOTE"
        fieldName="debunkeringDocument"
        testId="debunkeringDocument-upload"
      />
    );
  }

  return null;
};

export default PortServiceUploadResolver;
